/* eslint-disable */
import type { RequestContext } from "../../../franklin/RequestContextProto.pb";
import type { ResponseContext } from "../../../franklin/ResponseContextProto.pb";
import type { RatePlan } from "../../../franklin/rate_plan.pb";
import type { Avatar } from "../../../franklin/ui.pb";

export interface SetAccountholderProfileRequest {
  customer_token?: string;
  accountholder_customer_token?: string;
}

export interface SetAccountholderProfileResponse {
  customer_token?: string;
  /** TODO: Add metadata in the future */
  accountholder_customer_token?: string;
}

export interface GetProfileRequest {
  customer_token?: string;
}

export interface GetProfileResponse {
  customer_token?: string;
  accountholder_customer_token?: string;
}

export interface GetProfilesByAccountholderRequest {
  accountholder_customer_token?: string;
}

export interface GetProfilesByAccountholderResponse {
  profiles?: GetProfilesByAccountholderResponseProfile[];
}

export interface GetProfilesByAccountholderResponseProfile {
  customer_token?: string;
  accountholder_customer_token?: string;
}

export interface SwitchProfileRequest {
  target_profile_id?: string;
  request_context?: RequestContext;
}

export interface SwitchProfileResponse {
  response_context?: ResponseContext;
}

export interface SwitchProfileAdminRequest {
  session_token?: string;
  target_profile_id?: string;
}

export interface SwitchProfileAdminResponse {
  session_token?: string;
}

/** Creates a secondary profile (if allowed) for a given account holder customer. */
export interface CreateSecondaryProfileRequest {
  rate_plan?: RatePlan;
  /** The customer for which to create the secondary profile. This must be the main accountholder token */
  customer_token?: string;
}

export interface CreateSecondaryProfileResponse {
  /** The new customer profile that was just created */
  customer_token?: string;
}

/** Full profile is displayed to the user during switching */
export interface FullProfile {
  profile_id?: string;
  title?: string;
  cash_tag?: string;
  avatar?: Avatar;
  is_business?: boolean;
}

/** External APIs */
export interface GetProfilesRequest {
}

export interface GetProfilesResponse {
  profiles?: FullProfile[];
}

export interface CreateProfileRequest {
  idempotency_token?: string;
  rate_plan?: RatePlan;
}

export interface CreateProfileResponse {
  profile_token?: string;
  /** If a status occurred */
  status?: CreateProfileResponseStatus;
}

export enum CreateProfileResponseStatus {
  SUCCESS = "SUCCESS",
  /** FAILURE_UNEXPECTED - Unexpected internal error, retry */
  FAILURE_UNEXPECTED = "FAILURE_UNEXPECTED",
  /** FAILURE_IDEMPOTENT_CONFLICT - The idempotent key was already used to create a profile */
  FAILURE_IDEMPOTENT_CONFLICT = "FAILURE_IDEMPOTENT_CONFLICT",
  /** FAILURE_PROFILE_LIMIT - Max number of profiles were created */
  FAILURE_PROFILE_LIMIT = "FAILURE_PROFILE_LIMIT",
}
